import { twMerge } from 'tailwind-merge'

import Skeleton from './skeleton'
import Box from '../box/box'

const skeletonBaseStyles = 'w-full rounded-[5px]'

export const ListSideMedianSkeleton = ({ className }: { className?: string }) => {
  return (
    // TODO: Eventually we'll add borders everywhere, `border-none` is temporary for now
    <Box className={twMerge('border-none p-5 [&>*]:flex-grow-0', className)} data-testid="list-side-median-skeleton">
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-[15px] h-[26px] max-w-[217px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-2 h-5 max-w-[264px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-[15px] h-5 max-w-[248px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-[39px] h-[34px] max-w-[127px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-[15px] h-[26px] max-w-[217px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-2 h-5 max-w-[264px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'mb-[15px] h-5 max-w-[248px]')} />
      <Skeleton className={twMerge(skeletonBaseStyles, 'h-[34px] max-w-[127px]')} />
    </Box>
  )
}
